import React from 'react';

/** Shimmering placeholder block. `<Skeleton className="h-5 w-40" />` */
export default function Skeleton({ className = 'h-4 w-full', style }) {
  return <span aria-hidden="true" style={style} className={`skeleton block ${className}`} />;
}

const WIDTHS = ['100%', '94%', '97%', '88%', '91%'];

/** A paragraph of shimmering lines; the last line is shorter. `<SkeletonLines lines={3} />` */
export function SkeletonLines({ lines = 3, className = '', lineClassName = 'h-3.5' }) {
  return (
    <span role="status" aria-label="Loading" className={`block space-y-2.5 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={lineClassName} style={{ width: i === lines - 1 && lines > 1 ? '62%' : WIDTHS[i % WIDTHS.length] }} />
      ))}
    </span>
  );
}

export { Skeleton };
